export default __webpack_public_path__ + "static/media/icelevel.97717d53.png";